























































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { genesisIdToNetwork } from '../utils'

@Component({ name: 'AccountSummary' })
export default class AccountSummary extends Vue {
    private address = ''
    get price() { return this.$store.state.price }
    get isMainNet() { return genesisIdToNetwork(this.$connex.thor.genesis.id) === 'main' }
    private account = {
        entity: null as Connex.Thor.Account | null,
        error: null as Error | null
    }

    private code = {
        entity: null as Connex.Thor.Code | null,
        error: null as Error | null,
        loading: false
    }
    private sponsor = {
        addr: '',
        error: null as Error | null,
    }
    private master = {
        addr: '',
        error: null as Error | null,
    }

    @Watch('$store.state.chainStatus')
    private async reload() {
        this.loadBalance()
        this.loadMaster()
        this.loadSponsor()
    }
    private async loadBalance() {
        const acc = this.$connex.thor.account(this.address)
        try {
            this.account.entity = await acc.get()
            this.account.error = null
        } catch (err) {
            this.account.error = err
        }
    }
    private async loadMaster() {
        try {
            const method = this.$connex.thor
                .account(prototypeAddress)
                .method(masterJsonABI)

            if (method.cache) {
                method.cache([this.address])
            }
            const out = await method
                .call(this.address)

            const addr = out.decoded![0]
            this.master.addr = addr === zeroAddress ? 'N/A' : addr
            this.master.error = null
        } catch (err) {
            this.master.error = err
        }
    }
    private async loadSponsor() {
        try {
            const method = this.$connex.thor
                .account(prototypeAddress)
                .method(currentSponsorJsonABI)

            if (method.cache) {
                method.cache([this.address])
            }

            const out = await method
                .call(this.address)

            const addr = out.decoded![0]
            this.sponsor.addr = addr === zeroAddress ? 'N/A' : addr
            this.sponsor.error = null
        } catch (err) {
            this.sponsor.error = err
        }
    }

    private async loadCode() {
        try {
            this.code.loading = true
            this.code.entity = await this.$connex.thor.account(this.address).getCode()
            this.code.error = null
        } catch (err) {
            this.code.error = err
        } finally {
            this.code.loading = false
        }
    }
    private created() {
        this.address = this.$route.params.address.toLowerCase()
        this.reload()
    }
}

const prototypeAddress = '0x000000000000000000000050726f746f74797065'
const zeroAddress = '0x0000000000000000000000000000000000000000'

const masterJsonABI = {
    constant: true,
    inputs: [
        {
            name: '_self',
            type: 'address'
        }
    ],
    name: 'master',
    outputs: [
        {
            name: '',
            type: 'address'
        }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
}

const currentSponsorJsonABI = {
    constant: true,
    inputs: [
        {
            name: '_self',
            type: 'address'
        }
    ],
    name: 'currentSponsor',
    outputs: [
        {
            name: '',
            type: 'address'
        }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
}
